module.exports = __webpack_public_path__ + "static/media/code.d588b6ed.svg";